import React from 'react';
import { Block } from '@guryou/html-components';

const InfoContainer = ({ children }) => {
  return (
    <Block lg={5.6} md={5.8} xs={12} padding={10} backgroundColor="#f0f0f0">
      {children}
    </Block>
  );
};

export default InfoContainer;
